export function deixarPrimeiraLetraMaiuscula(frase: string) {
  return frase.charAt(0).toUpperCase() + frase.slice(1);
}
